import { FC } from 'react';
import { IRouteGroup } from '../../../types';
import NavbarItem from './item';

const NavbarGroup: FC<IRouteGroup> = (props) => {

  const {
    group,
    routes,
  } = props;

  const RouteList = routes.map((route, i) => <NavbarItem key={i} {...route} />);

  // don't show a group name for undefined ones
  if (group === 'undefined')
    return (
      <>
        {RouteList}
      </>
    );

  return (
    <span className="navbar-item">
      <span>
        {group}
      </span>
      {RouteList}
    </span>
  );

};

export default NavbarGroup;
